import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { JwtService } from "app/generic/JwtService";
import { NewModalService } from "app/generic/new-modal/new-modal.service";
import { environment } from "environments/environment";


@Injectable()
export class TaComunicazioniService extends JwtService {

  constructor(private http: HttpClient,
      public router: Router,
      public modalComponent: NewModalService) {
      super(router, modalComponent);
    }

  selectAll():Promise<any>{

    return this.http.get(environment.apiEndpoint+'/CentroFunzionalePortaleRest/rest/articoli/findAll', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }


  findById(idArticolo:any):Promise<any>{
    
        return this.http.get(environment.apiEndpoint+'/CentroFunzionalePortaleRest/rest/articoli/findById/'+idArticolo, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }



  findLastTwo():Promise<any>{
        return this.http.get(environment.apiEndpoint+'/CentroFunzionalePortaleRest/rest/articoli/findLastTwo', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }

  delete(id: number): Promise<any> {

    return this.http.delete(environment.apiEndpoint+'/CentroFunzionalePortaleRest/rest/articoli/delete/' + id, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }

}
